import { defineComponent, computed, resolveComponent, openBlock, createBlock, resolveDynamicComponent, normalizeClass, withKeys, withCtx, createElementVNode, createCommentVNode, createElementBlock, renderSlot, createTextVNode, toDisplayString } from 'vue';
import SSRIcon from '@ingka/ssr-icon-vue';
import warningTriangle from '@ingka/icons-shared/paths/warning-triangle';

const INVERSE_TYPES = ['primary', 'emphasised', 'secondary', 'tertiary'];
var script = defineComponent({
    name: 'SkapaButton',
    components: {
        SSRIcon
    },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        expanding: {
            type: Boolean,
            default: false
        },
        fluid: {
            type: Boolean,
            default: false
        },
        text: {
            type: String,
            default: null
        },
        type: {
            type: String,
            default: 'secondary'
        },
        small: {
            type: Boolean,
            default: false
        },
        xsmallIconOnly: {
            type: Boolean,
            default: false
        },
        href: {
            type: String,
            default: null
        },
        newWindow: {
            type: Boolean,
            default: false
        },
        loadingSrText: {
            type: String,
            default: 'Loading…'
        },
        ssrIcon: {
            type: Array,
            default: () => []
        },
        iconOnly: {
            type: Boolean,
            default: false
        },
        prefix: {
            type: String,
            default: ''
        },
        htmlType: {
            type: String,
            default: 'button'
        },
        loading: {
            type: Boolean,
            default: false
        },
        iconPosition: {
            type: String,
            default: 'leading'
        },
        inverseTheme: {
            type: Boolean,
            default: false
        },
        expandedOnTouchDevice: {
            type: Boolean,
            default: false
        }
    },
    emits: ['click'],
    setup(props, { emit }) {
        const onClick = (event) => {
            emit('click', event);
        };
        const onSpaceBarKeyUp = (event) => {
            event.target.click();
        };
        const iconPath = computed(() => props.type === 'danger' ? warningTriangle : props.ssrIcon);
        if (props.inverseTheme && !INVERSE_TYPES.includes(props.type)) {
            throw new Error(`Button: The "inverseTheme" prop is not applicable with variant "${props.type}"`);
        }
        return { onClick, onSpaceBarKeyUp, iconPath };
    }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SSRIcon = resolveComponent("SSRIcon");

  return (openBlock(), createBlock(resolveDynamicComponent(_ctx.href ? 'a' : 'button'), {
    type: !_ctx.href ? _ctx.htmlType : null,
    role: _ctx.href && 'button',
    "aria-disabled": _ctx.loading || null,
    disabled: !_ctx.href ? _ctx.disabled : null,
    href: _ctx.href,
    target: _ctx.href && _ctx.newWindow ? '_blank' : null,
    class: normalizeClass([
      `${_ctx.prefix}btn`,
      {
        [`${_ctx.prefix}btn--expanding`]: _ctx.expanding,
        [`${_ctx.prefix}btn--touch-device-expanded`]: _ctx.expanding && _ctx.expandedOnTouchDevice,
        [`${_ctx.prefix}btn--fluid`]: _ctx.fluid && !_ctx.iconOnly,
        [`${_ctx.prefix}btn--loading`]: _ctx.loading,
        [`${_ctx.prefix}btn--small`]: _ctx.small,
        [`${_ctx.prefix}btn--xsmall`]: _ctx.iconOnly && _ctx.xsmallIconOnly,
        [`${_ctx.prefix}${_ctx.iconPosition}-icon`]: !_ctx.iconOnly && _ctx.iconPath.length > 0,
        [`${_ctx.prefix}btn--${_ctx.type}`]: !_ctx.inverseTheme && !_ctx.iconOnly,
        [`${_ctx.prefix}btn--${_ctx.type}-inverse`]: _ctx.inverseTheme && !_ctx.iconOnly,
        [`${_ctx.prefix}btn--icon-${_ctx.type}`]: _ctx.iconOnly && !_ctx.inverseTheme,
        [`${_ctx.prefix}btn--icon-${_ctx.type}-inverse`]: _ctx.iconOnly && _ctx.inverseTheme
      }
    ]),
    onKeyup: withKeys(_ctx.onSpaceBarKeyUp, ["space"]),
    onClick: _ctx.onClick
  }, {
    default: withCtx(() => [
      createElementVNode("span", {
        class: normalizeClass(`${_ctx.prefix}btn__inner`)
      }, [
        (_ctx.iconPath.length > 0)
          ? (openBlock(), createBlock(_component_SSRIcon, {
              key: 0,
              class: normalizeClass(`${_ctx.prefix}btn__icon`),
              paths: _ctx.iconPath,
              prefix: _ctx.prefix
            }, null, 8 /* PROPS */, ["class", "paths", "prefix"]))
          : createCommentVNode("v-if", true),
        (_ctx.text || _ctx.$slots.text)
          ? (openBlock(), createElementBlock("span", {
              key: 1,
              class: normalizeClass(`${_ctx.prefix}btn__label`)
            }, [
              renderSlot(_ctx.$slots, "text", {}, () => [
                createTextVNode(toDisplayString(_ctx.text), 1 /* TEXT */)
              ])
            ], 2 /* CLASS */))
          : createCommentVNode("v-if", true),
        renderSlot(_ctx.$slots, "default"),
        (_ctx.loading)
          ? (openBlock(), createElementBlock("span", {
              key: 2,
              class: normalizeClass(`${_ctx.prefix}btn__loader`)
            }, toDisplayString(_ctx.loadingSrText), 3 /* TEXT, CLASS */))
          : createCommentVNode("v-if", true)
      ], 2 /* CLASS */)
    ]),
    _: 3 /* FORWARDED */
  }, 40 /* PROPS, HYDRATE_EVENTS */, ["type", "role", "aria-disabled", "disabled", "href", "target", "class", "onKeyup", "onClick"]))
}

script.render = render;
script.__file = "packages/vue/button/lib/Button.vue";

export { script as default };
